import { Component, OnInit } from '@angular/core';
import { DaoService } from '../servicos/dao.service';

@Component({
  selector: 'app-autenticador',
  templateUrl: './autenticador.component.html',
  styleUrls: ['./autenticador.component.css']
})
export class AutenticadorComponent implements OnInit {

  constructor(public dao:DaoService) { }

  ngOnInit() {
    this.resultado = this.dao.validarCPF(this.cpf);
  }


  cpf:any = '01676080618';
  resultado:any;

  


}
